import { actionType } from "../actions/rettekoderActions";
import * as reducerUtils from "../utils/reducerUtils";

const INITIAL_STATE = [];
const rettekoderReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default rettekoderReducer;
